import { createClient } from "@supabase/supabase-js";

const fallbackUrl = "https://pymbcftbscskwzypxalo.supabase.co";
const fallbackAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5bWJjZnRic2Nza3d6eXB4YWxvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3NzkxOTAsImV4cCI6MjA4MDM1NTE5MH0.92bJDMQ9_TR_gPM-LNS979MAIscIsUlBVCpO_uQfA0U";

const envUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
const envAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

const supabaseUrl = envUrl || fallbackUrl;
const supabaseAnonKey = envAnonKey || fallbackAnonKey;
const isUsingFallbackSupabaseConfig = !envUrl || !envAnonKey;

const supabase = createClient(supabaseUrl, supabaseAnonKey);

async function getBusinesses() {
  const { data, error } = await supabase
    .from("users")
    .select("*")
    .eq('type', 'Business');

  if (error) {
    console.error("Error fetching businesses:", error);
  } else {
    return data;
  }
}

export {
	supabase,
	getBusinesses,
  supabaseUrl,
  isUsingFallbackSupabaseConfig,
}
